import { TabbedItemPage } from './TabbedItemPage';

export const OrganisationPage = () => <TabbedItemPage itemPath="/maintenance/organisation" />;
